import { readFile, utils, writeFile } from 'xlsx';
import { getDmY } from './date';

class Excel {

    static mapToSp(_item) {
        return ({
            speedLimit: _item["Speed limit"],
            location: {latitude: _item["Latitude"], longitude: _item["Longitude"]},
            code: _item["Code"],
            radius: _item["Radius"],
            destinationCity: _item["Destination city"],
            departureCity: _item["Departure city"]
        });
    }

    static readFile(_file) {
        let data = [];
        try {
            console.log("File : ", _file);
            const wb = readFile(_file);
            data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
            console.log("Excel : ", data);
        } catch (e) {
            console.log("Error Excel : ", e);
        }

        return data;
    }

    static writeFile(_json, _name = "name", _bookType = "xlsx") {
        try {
            const ws = utils.json_to_sheet(_json);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "" + getDmY());
            let ext = "." + _bookType;
            writeFile(wb, _name + "__" + getDmY() + ext, {compression: true, bookType: _bookType});
        } catch (e) {
            console.log("Error writting Excel: ", e);
        }
    }

}

export default Excel;